<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1>Events in Firebase Database</h1>
    <div class="row">
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-4"><sa-input-text [(text)]="type" [title]="'type' "></sa-input-text></div>
                <div class="col-md-4"><sa-input-text [(text)]="scenario" [title]="'scenario' "></sa-input-text></div>
                <div class="col-md-4"><sa-input-text [(text)]="player" [title]="'player' "></sa-input-text></div>
            </div>
            <button class="btn btn-primary btn-sm" style="margin:10px" (click)="filter()">Filter</button>
            <button class="btn btn-primary btn-sm" style="margin:10px" (click)="clear()">Clear</button>
            <button class="btn btn-primary btn-sm" style="margin:10px" (click)="refresh()">Refresh</button>
        </div>
        <div class="col-md-2">

        </div>
        <div class="col-md-4">
            Delete older than 
            <sa-input-number [(text)]="minutes" [title]="''" style="max-width:100px;display:inline-block"></sa-input-number> 
            minutes
            <button class="btn btn-primary btn-sm" style="margin:10px" (click)="deleteAll()">Delete</button>
        </div>
    </div>
    <br>
    {{eventsArrayDisplay.length}} records
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Property</th>
                <th>Type</th>
                <th>Scenario</th>
                <th>Player</th>
                <th>TimeStamp</th>
                <th>Time ago</th>
                <th>Data</th>
                <th>Delete</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of eventsArrayDisplay">
                <td>{{item.property}}</td>
                <td>{{item.type}}</td>
                <td>{{item.scenarioid}}</td>
                <td>{{item.playerid}}</td>
                <td>{{item.timestamp}}</td>
                <td>{{item.datetime}}</td>
                <td>{{item.data | json}}</td>
                <td><button class="btn btn-warning btn-sm" (click)="deleteEvent(item)">Delete</button></td>
            </tr>
        </tbody>
    </table>
